export type AdminRole =
  | "UPDATE_TENANT"
  | "GET_EPISODES"
  | "get:device:config"
  | "READ_SITES"
  | "revoke:permission"
  | "get:polyplusentitlement"
  | "delete:role"
  | "remove:permission"
  | "READ_TENANT_EVENTS"
  | "update:device"
  | "fetch:accessor"
  | "add:permission"
  | "revoke:role"
  | "associate:resource"
  | "CREATE_TENANT"
  | "grant:permission"
  | "register:device"
  | "CREATE_USER"
  | "set:device:config"
  | "fetch:permission"
  | "update:integrations"
  | "license:WriteTenant"
  | "nc:core:readActions"
  | "MERGE_TENANT"
  | "READ_TENANT"
  | "grant:role"
  | "register:edge"
  | "create:role"
  | "activate:polypluslicense"
  | "unregister:device"
  | "get:device:connections"
  | "fetch:role"
  | "ACTIVATE_TENANT"
  | "UPDATE_SITES"
  | "get:polypluslicense"
  | "disassociate:resource"
  | "license:ReadTenant"
  | "upload:device:logs"
  | "read:device"
  | "entitle:polyplusentitlement"
  | "remove:accessor"
  | "nc:poly:configure"
  | "nc:teams:configure"
  | "RESOLVE_TENANT"
  | "access:device:logs"
  | "register:accessor"
  | "fetch:collection"
  | "DELETE_USER"
  | "READ_USER_INVITES"
  | "READ_USERS"
  | "license:ReadTenant"
  | "license:WriteTenant"
  | "read:policy"
  | "read:device:resource:file"
  | "add:device:resource:file"
  | "delete:device:resource:file"
  | "read:usergroup"
  | "update:usergroup"
  | "delete:usergroup"
  | "export:device";
export type ItadminRole =
  | "GET_EPISODES"
  | "get:device:config"
  | "READ_SITES"
  | "READ_TENANT_EVENTS"
  | "update:device"
  | "fetch:accessor"
  | "CREATE_TENANT"
  | "register:device"
  | "set:device:config"
  | "fetch:permission"
  | "nc:core:readActions"
  | "READ_TENANT"
  | "unregister:device"
  | "get:device:connections"
  | "fetch:role"
  | "ACTIVATE_TENANT"
  | "UPDATE_SITES"
  | "get:polypluslicense"
  | "upload:device:logs"
  | "read:device"
  | "nc:poly:configure"
  | "nc:teams:configure"
  | "RESOLVE_TENANT"
  | "access:device:logs"
  | "fetch:collection"
  | "READ_USER_INVITES"
  | "READ_USERS"
  | "license:ReadTenant"
  | "read:device:resource:file"
  | "add:device:resource:file"
  | "delete:device:resource:file"
  | "read:usergroup"
  | "update:usergroup"
  | "delete:usergroup"
  | "export:device";
export type UserRole =
  | "GET_EPISODES"
  | "get:device:config"
  | "READ_SITES"
  | "READ_TENANT_EVENTS"
  | "fetch:accessor"
  | "CREATE_TENANT"
  | "fetch:permission"
  | "READ_TENANT"
  | "fetch:role"
  | "ACTIVATE_TENANT"
  | "get:polypluslicense"
  | "read:device"
  | "RESOLVE_TENANT"
  | "READ_USER_INVITES"
  | "READ_USERS"
  | "license:ReadTenant"
  | "read:device:resource:file";
export type InternalserviceRole =
  | "READ_TENANT"
  | "RESOLVE_TENANT"
  | "ALIAS_TENANT"
  | "READ_TENANT_EVENTS";
export type DeviceuserRole =
  | "fetch:accessor"
  | "fetch:permission"
  | "fetch:role"
  | "ACTIVATE_TENANT"
  | "register:device"
  | "unregister:device"
  | "register:device:enduser";
export type ClaritiPolyAdminRole = "license:PolyRead" | "license:PolyWrite";
export type ClaritiTrialAdminRole =
  | "clariti-trial:DeleteSubscriptions"
  | "clariti-trial:ReadSubscriptions"
  | "clariti-trial:UpdateSubscriptions";
export type AllRolePermissions =
  | AdminRole
  | ItadminRole
  | UserRole
  | InternalserviceRole
  | DeviceuserRole
  | ClaritiPolyAdminRole
  | ClaritiTrialAdminRole;

const fallbackRole = "NONE";

export const InternalRoleNames = ["poly-admin", "poly-support"];
export type InternalRoleName = typeof InternalRoleNames[number];

export const MemberRoleNames = [
  "user",
  "admin",
  "it-admin",
  "sp-admin",
  "sp-it-admin",
  "disti-admin",
  "disti-it-admin"
];
export type MemberRoleName = typeof MemberRoleNames[number];

export const RoleNames = [
  ...InternalRoleNames,
  ...MemberRoleNames,
  fallbackRole
];
export type RoleName = typeof RoleNames[number];

export default AllRolePermissions;
